<template>
    <div class="text-sm mb-3">
        <span class="font-medium text-info text-base">Détails du contrat</span>
        <template v-if="intervention.contract">
            <contract-informations class="mt-3" :contract="intervention.contract"></contract-informations>
            <md-divider class="my-2"></md-divider>
            <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-100">
                    <span class="text-base font-medium">Plan d'intervention</span>
                    <template v-if="hasInterventionPlan()">
                        <div class="flex flex-col divide-y-2 divide-gray-200 mt-2">
                            <intervention-plan-card v-for="planningInterventionGroup in intervention.contract.intervention_plan.planning_intervention_groups" :key="planningInterventionGroup.id"
                                                    :intervention-plan="planningInterventionGroup">
                            </intervention-plan-card>
                        </div>
                    </template>
                    <p v-else>Aucun plan d'intervention pour ce contrat.</p>
                </div>
            </div>
        </template>
        <p v-else>Pas de contrat pour cette intervention</p>
    </div>
</template>

<script>
import ContractInformations from "@/pages/Contracts/components/ContractInformations";
import InterventionPlanCard from "@/pages/Contracts/InterventionPlan/components/InterventionPlanCard";
export default {
    name: "TabContract",
    components: {
        ContractInformations, InterventionPlanCard
    },
    props: {
        interventionId: Number,
        active: Boolean
    },
    data() {
        return {
            intervention: {
                contract: null,
                planning_intervention_prevision: null
            }
        }
    },
    methods: {
        async getContractDetails() {
            const { data } = await this.$store.dispatch('calendar/getModalContract', {
                interventionId: this.interventionId
            })
            this.intervention = data
        },
        hasInterventionPlan() {
            return !!(this.intervention.contract.intervention_plan && this.intervention.contract.intervention_plan.planning_intervention_groups.length > 0)
        },
        isActive(state) {
            return state ? 'Oui' : 'Non'
        },
    },
    mounted() {
        if(this.active) {
            this.getContractDetails()
        }
    },
    watch: {
        active(newVal) {
            if(newVal) {
                this.getContractDetails()
            }
        }
    }
}
</script>

<style scoped>

</style>
